//@flow

const IGNORED_ERROR_KEYS = new Set(['ref', 'type', 'types']);

function isPlainObject(value: any): boolean {
  return (
    value != null &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    Object.prototype.toString.call(value) === '[object Object]'
  );
}

export function getFormError(errors: any, path: string): ?string {
  if (!errors) return null;

  const parts = path.split('.');
  let current = errors;

  for (let index = 0; index < parts.length; index += 1) {
    const part = parts[index];
    if (!current || current[part] == null) return null;
    current = current[part];
  }

  if (!current) return null;
  if (typeof current === 'string') return current;
  if (typeof current.message === 'string') return current.message;

  return null;
}

export function flattenFormErrors(
  errors: any,
  visited: WeakSet<any> = new WeakSet()
): string[] {
  if (!isPlainObject(errors)) return [];
  if (visited.has(errors)) return [];

  visited.add(errors);

  return Object.keys(errors).reduce((messages, key) => {
    if (IGNORED_ERROR_KEYS.has(key)) return messages;

    const error = errors[key];
    if (!error) return messages;

    if (typeof error === 'string') {
      return messages.concat(error);
    }

    if (typeof error.message === 'string') {
      return messages.concat(error.message);
    }

    if (isPlainObject(error)) {
      return messages.concat(flattenFormErrors(error, visited));
    }

    return messages;
  }, []);
}

export function applyValidationErrors(
  setError: (name: string, type: string, message: string) => void,
  validationErrors: {[key: string]: string}
) {
  Object.keys(validationErrors).forEach(field => {
    setError(field, 'manual', validationErrors[field]);
  });
}

export function collectValidationMessages(
  customErrors: {[key: string]: string} = {}
): string[] {
  return [...new Set(Object.values(customErrors).filter(Boolean))];
}
